module.exports = __webpack_public_path__ + "img/jishu.d12436fa.jpg";